import React from "react";

const DropdownLanguagesOverlay = (props) => {
  const { selectedLanguage = {}, onSelectLanguage, availableLanguages = [] } = props;
  const languages = availableLanguages.filter((lang) => lang.code !== selectedLanguage.code);
  const onSelect = (lang) => () => onSelectLanguage(lang);

  return (
    <ul>
      {languages.map((lang) => {
        const handleSelect = onSelect(lang);
        return (
          <li key={lang.code}>
            <button
              type="button"
              onClick={handleSelect}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
                width: "100%",
                display: "flex",
                alignItems: "center",
                textAlign: "left"
              }}
            >
              <img src={lang.icon} alt="language-flag" />
              <span>{lang.title}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default DropdownLanguagesOverlay;
